import './styles/index.scss' // global css
import './utils/pollFill'
import App from './App'
import router from './router'
import store from './store'

import i18n from './lang' // Internationalization
import './errorLog'// error log
import './permission' // permission control
import './mixin/index.js' // mixin

// import netService from '@/service/net-service'

import * as filters from './filters' // global filters
Vue.config.devtools = true
Vue.use(ELEMENT, {
  size: 'medium', // set element-ui default size
  i18n: (key, value) => i18n.t(key, value)
})

// register global utility filters.
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})

// Vue.use(netService)

Vue.config.productionTip = false
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  i18n,
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js